import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

/**
 * Guard for the maintenance page route itself
 * Only allows access when maintenance mode is active
 * If maintenance is not active, redirects to home page
 */
export const maintenancePageGuard: CanActivateFn = async (
    route,
    state
): Promise<boolean | UrlTree> => {
    const maintenanceService = inject(MaintenanceService);
    const router = inject(Router);

    const isMaintenanceActive = await maintenanceService.isMaintenanceActive();

    if (!isMaintenanceActive) {
        // Maintenance is not active, redirect to home
        return router.createUrlTree(['/']);
    }

    // Maintenance is active, allow access to maintenance page
    return true;
};
